import { z } from 'zod/v4';

/** --- StoredData --- */
export const storedDataSchema = z
  .object({
    refreshToken: z.string().nullable().optional(),
  })
  .catchall(z.any());
export type StoredData = z.infer<typeof storedDataSchema>;

export const tokenCacheSchema = z.record(
  z.string(), // Token address
  z.object({
    symbol: z.string(),
    decimals: z.number(),
  })
);

export const formatterCacheSchema = z.object({
  tokenCache: tokenCacheSchema,
});

export type TokenCache = z.infer<typeof tokenCacheSchema>;
export type FormatterCache = z.infer<typeof formatterCacheSchema>;
